import React from 'react'
import {useSelector} from 'react-redux'
import {useTranslation} from 'react-i18next'

import './index.less'
import './mobile.less'

import Layout from '@/components/Layout'
import ContentHeader from '@/components/ContentHeader'
import ContactForm from '@/components/ContactForm'
import GoogleMaps from '@/components/GoogleMaps'
import WechatPopover from '@/components/WechatPopover'

import bannerImg from '@/assets/img/contactUs/banner.jpg'
import wechatImg from '@/assets/img/icon/wechat.png'
import instagramImg from '@/assets/img/icon/instagram.png'
import facebookImg from '@/assets/img/icon/facebook.png'
import {FACEBOOK_LINK, IG_LINK} from "@/constants"

export default function ContactUs() {
  const {t} = useTranslation()
  
  const commonState = useSelector(state => state.common)
  const rootClassName = commonState.isMobile ? 'contact-us-mobile-container' : 'contact-us-container'
  
  return (
    <Layout isShowFooterTop={true}>
      <div className={rootClassName}>
        <ContentHeader
          className={'contact-us-header-container'}
          des={t('')}
          title={t('CONTACT US')}
          banner={''}
        />
        <div className={'contact-us-content-container'}>
          <div className={'company-info'}>
            <div>
              Thanks for visiting Chun Yuen Trading! Have a question? Get in touch with our team if you want to learn more about our food!
            </div>
            <div>
              <span className={'label'}>{t('Email')}: </span>
              chunyuentradinginc@hotmail.com
            </div>
            <div>
              <span className={'label'}>{t('Phone')}: </span>
              626-454-3233
            </div>
          </div>
          <ContactForm/>
          {/*<div className={'contact-us-content-right-container'}>
            <div className={'contact-us-content-right-working-hours-container'}>
              <div className={'contact-us-content-right-title'}>{t('WORKING HOURS')}</div>
              <div className={'contact-us-content-right-working-hours-item-container'}>
                {t('Monday - Friday')}
                <span>: {t('8:30am - 4pm')}</span>
              </div>
            </div>
            <div className={'contact-us-content-right-contact-us-container'}>
              <div className={'contact-us-content-right-title'}>{t('LOCATION')}</div>
              <div className={'contact-us-content-right-contact-us-title'}>
                10922 Klingerman Street, Suite #3,
              </div>
              <div className={'contact-us-content-right-contact-us-des'}>
                S El Monte, CA 91733
              </div>
              <div className={'contact-us-content-right-contact-us-des'}>
                {t('Phone')}: 626-454-3233
              </div>
            </div>
            <div className={'contact-us-content-right-social-medias-container'}>
              <div className={'contact-us-content-right-title'}>{t('SOCIAL MEDIAS')}</div>
              <div className={'contact-us-content-right-social-medias-list'}>
                <WechatPopover>
                  <div className={'contact-us-content-right-social-medias-item-container'}>
                    <img src={wechatImg} alt="wechat" />
                  </div>
                </WechatPopover
                <div 
                  className={'contact-us-content-right-social-medias-item-container'}
                  onClick={() => window.open(IG_LINK)}
                >
                  <img src={instagramImg} alt="instagram" />
                </div>
                <div 
                  className={'contact-us-content-right-social-medias-item-container'}
                  onClick={() => window.open(FACEBOOK_LINK)}>
                  <img src={facebookImg} alt="facebook" />
                </div>
              </div>
            </div>
            <div className={'contact-us-content-right-map-container'}>
              <GoogleMaps zoomControl={!commonState.isMobile}/>
            </div>
          </div>*/}
        </div>
      </div>
    </Layout>
  )
}
